import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDino: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dino, age, old"><path d="M16 10.5C8.96912 6.22033 7.17125 9.97708 5.46456 13.5433C4.54613 15.4624 3.65411 17.3263 1.98719 17.853C1.46057 18.0194 1 18.4477 1 19C1 19.5523 1.44771 20 2 20H6V21C6 21.5523 6.44772 22 7 22H9C9.55229 22 10 21.5523 10 21V20H13V21C13 21.5523 13.4477 22 14 22H16C16.5523 22 17 21.5523 17 21V19.1973C18.7934 18.1599 20 16.2208 20 14V6.5L21.581 5.70948C21.8378 5.5811 22 5.3144 22 5.02733C22 3.37047 20.6569 2 19 2C17.3431 2 16 3.34315 16 5V10.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDino;
